export enum SortDirection {
  Asc = 1,
  Desc,
}
